module.exports = __webpack_public_path__ + "img/image_2_2.ec00d3e6.png";